import React from 'react';
import { Label } from 'semantic-ui-react';

const RoleActionsLabelGroup = ({ roleActions, disabled }) => (
  <Label.Group className="mt-5" disabled={disabled}>
    {roleActions.map((roleAction) => (
      <Label basic key={roleAction.name}>
        {roleAction.name}
      </Label>
    ))}
  </Label.Group>
);

export default RoleActionsLabelGroup;
